function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawAirSupport = function UndrawAirSupport(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 883 711.86",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 600,
    y1: 803.52,
    x2: 600,
    y2: 630.46,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 199.26,
    y1: 162.3,
    x2: 199.26,
    y2: 0,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 2855.02,
    y1: 635.26,
    x2: 2855.02,
    y2: 635.22,
    gradientTransform: "matrix(-1 0 0 1 3466 0)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 2849.78,
    y1: 664.28,
    x2: 2849.78,
    y2: 634.41,
    gradientTransform: "matrix(-1 0 0 1 3466 0)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 902.47,
    y1: 538.96,
    x2: 902.47,
    y2: 500.17,
    gradientTransform: "rotate(.13 41963.117 -69459.298)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 910.63,
    y1: 452.78,
    x2: 910.63,
    y2: 204.14,
    xlinkHref: "#prefix__a"
  })), React.createElement("rect", {
    x: 636.34,
    y: 24.91,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 681.33,
    y: 43.39,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 605,
    y: 59.46,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 292.46,
    y: 273.18,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 337.45,
    y: 291.66,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 261.12,
    y: 307.72,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M1011 780.22c-4.82 0-115.7 48.21-244.25-78.74-69.81-68.93-138.19-76.27-186.11-68.58-29.45 4.72-56.34 19.1-77.64 39.93-17.13 16.82-58.59 39.74-155.73 33.48-149.44-9.64-188.81 97.22-188.81 97.22h883s-25.67-23.31-30.46-23.31z",
    transform: "translate(-158.5 -94.07)",
    fill: "url(#prefix__a)",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M0 711.86S39.37 605 188.81 614.64c97.14 6.29 138.61-16.66 155.69-33.47 21.26-20.87 48.14-35.21 77.56-39.93 47.92-7.69 116.31-.35 186.11 68.58 128.55 126.95 239.43 78.74 244.25 78.74s30.53 23.3 30.53 23.3z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M0 711.86S39.37 605 188.81 614.64c97.14 6.29 138.61-16.66 155.69-33.47 21.26-20.87 48.14-35.21 77.56-39.93 47.92-7.69 116.31-.35 186.11 68.58 128.55 126.95 239.43 78.74 244.25 78.74s30.53 23.3 30.53 23.3z",
    opacity: 0.02
  }), React.createElement("rect", {
    x: 91.59,
    y: 123.73,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 136.59,
    y: 142.21,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 60.26,
    y: 158.28,
    width: 200.86,
    height: 21.69,
    rx: 9.96,
    ry: 9.96,
    fill: "#f2f2f2"
  }), React.createElement("circle", {
    cx: 199.26,
    cy: 81.15,
    r: 81.15,
    fill: "url(#prefix__b)",
    opacity: 0.5
  }), React.createElement("circle", {
    cx: 199.26,
    cy: 81.15,
    r: 72.31,
    fill: "#fccc63"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M160.98 590.63h62.9v46.73h-62.9z"
  }), React.createElement("path", {
    d: "M155.5 588.73l35.15-35.15a2.74 2.74 0 0 1 3.88 0l34.87 34.87a2.74 2.74 0 0 1-1.93 4.68l-70 .28a2.74 2.74 0 0 1-1.97-4.68z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M155.5 588.73l35.15-35.15a2.74 2.74 0 0 1 3.88 0l34.87 34.87a2.74 2.74 0 0 1-1.93 4.68l-70 .28a2.74 2.74 0 0 1-1.97-4.68z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M191.62 616.28h1.26a7.1 7.1 0 0 1 7.1 7.1v14h-15.46v-14a7.1 7.1 0 0 1 7.1-7.1z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 192.6,
    cy: 562.17,
    r: 3.87,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M165.9 596.6h14.76v11.24H165.9z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M172.57 596.6h1.41v11.24h-1.41z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M205.25 596.6h14.76v11.24h-14.76z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M211.93 596.6h1.41v11.24h-1.41z"
  }), React.createElement("path", {
    d: "M611 635.22c-.13-.03 0 0 0 0z",
    transform: "translate(-158.5 -94.07)",
    fill: "url(#prefix__c)",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M612.45 664.26h.12a.14.14 0 0 0 .09-.12.32.32 0 0 0 0-.12v-.1c-.1-.24-.33-.56-.46-.84l-.06-.15a1.15 1.15 0 0 1 0-.2v-.09l2.16-7.09.05-.17s2.75 1.18 3.46 3.54a5.54 5.54 0 0 1 .06 3.55l-.05.12h.05v1.3h3c.21-.1-.07-.36-.35-.62l-.07-.07-.18-.19a.94.94 0 0 1-.13-.19l-.05-.12v-.07H620v-.11a10.21 10.21 0 0 0-3.06-9.66 10.46 10.46 0 0 0 0-6.65c.28-.2 5.73-4.14 5.69-9.24a7 7 0 0 0 0-.82s.47-.39 0-1.1v-.06h-.38a1.48 1.48 0 0 0-.61.2s-.31 1 0 1.26h-.08s-3.23 7-5.39 8l-.15-.09v-.91a1.1 1.1 0 0 0 0-.12 1.09 1.09 0 0 0 0-.11 2.45 2.45 0 0 0 .65-.49 2.45 2.45 0 0 0 .2-.24l.08-.12.08-.14.06-.13a2.42 2.42 0 0 0 .11-.29v-.27-.12-.16a2.43 2.43 0 0 0-.15-.84q0-.11-.09-.22l-.05-.11-.07-.12a.8.8 0 0 1 .19-.17 1.13 1.13 0 0 1 .45-.14H617.95a.7.7 0 0 0 .16-.09.73.73 0 0 1 .26-.14h-1.25l-.16-.07a.86.86 0 0 0 .26.06h.4l.06-.05v-.08h-.18a1.52 1.52 0 0 1-.41 0h-.42l-.12-.05A.46.46 0 0 0 617 638l.11-.07a.58.58 0 0 0 .2-.39.44.44 0 0 0 0-.19l-.07.06h-.06a1 1 0 0 1-.65.18h-.08a3 3 0 0 1-.59-.22l-.17-.06h-.91a3.05 3.05 0 0 0-2 .84 3 3 0 0 0-.34.4 3.92 3.92 0 0 1 .39-2.13h-.24l-.09.17a2 2 0 0 1 .27-.68h-.06a.81.81 0 0 0 0-1.08c-.47-.71-1.34-.16-1.34-.16a3.64 3.64 0 0 0-.14.71l-.14-.06c-.16.54-1.94 6.74 1 10.7a2.47 2.47 0 0 0 0 .25v6.68l-2 9.16-.39 1.73 2.81.46zm.5-21.65a2.44 2.44 0 0 0 .52.33 1.09 1.09 0 0 0 0 .19v.87l-.17.08c-.13-.43-.24-.93-.36-1.47z",
    transform: "translate(-158.5 -94.07)",
    fill: "url(#prefix__d)",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M464.16 542.86s.52-.44 0-1.22-1.48-.17-1.48-.17-.35 1.13 0 1.39 1.48 0 1.48 0z",
    fill: "#ca7070"
  }), React.createElement("path", {
    "data-name": "<Path>",
    d: "M458.78 572.02h2.4a.79.79 0 0 0 .23.62c.32.37 1 .82.67 1h-3.3z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M461.23 572.64a.79.79 0 0 1-.23-.62h.17a.79.79 0 0 0 .23.62c.32.37 1 .82.67 1h-.17c.3-.18-.35-.63-.67-1z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    "data-name": "<Path>",
    d: "M450.22 571.53l2.28.4a1.15 1.15 0 0 0 .1.79c.25.51.8 1.17.47 1.31l-3.25-.53z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M451.32 541.8s-2.57 8.11 1.74 12.6l1.25-1s-2.55-8.85-1.12-10.93c-2.52-.79-1.87-.67-1.87-.67z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M453.1 542.51s.52-.44 0-1.22-1.48-.17-1.48-.17-.35 1.13 0 1.39 1.48 0 1.48 0z",
    fill: "#ca7070"
  }), React.createElement("path", {
    d: "M452.4 572.68a1.15 1.15 0 0 1-.1-.79l-2.08-.34 2.28.38a1.15 1.15 0 0 0 .1.79c.25.51.8 1.17.47 1.31h-.14c.22-.24-.29-.86-.53-1.35z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 612.51,
    y: 643.42,
    width: 2.44,
    height: 3.62,
    rx: 1.12,
    ry: 1.12,
    transform: "rotate(180 534.485 598.195)",
    fill: "#ca7070"
  }), React.createElement("path", {
    d: "M454.13 553.93s-2.52-8.74-1.15-10.89h.26c-1.43 2.08 1.12 10.93 1.12 10.93l-1.25 1-.11-.12z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 455.19,
    cy: 547.92,
    r: 2.7,
    fill: "#ca7070"
  }), React.createElement("path", {
    d: "M456.15 551.75v-1.18a1.21 1.21 0 0 0 0-.26 2.7 2.7 0 0 0-1.08-5.1h.15a2.7 2.7 0 0 1 1.24 5.1 1.21 1.21 0 0 1 0 .26v1.18a1.22 1.22 0 0 1-1.22 1.22h-.15a1.22 1.22 0 0 0 1.06-1.22z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M452.45 561.38s5.21.59 5.4 0a11.52 11.52 0 0 0 0-7.41 2.7 2.7 0 0 0-2.7-2.7 2.7 2.7 0 0 0-2.7 2.7z",
    fill: "#00695c"
  }), React.createElement("path", {
    d: "M452.45 561.38l-2.35 10.8h2.35l2.44-8s3 1.31 3.83 3.92a5.73 5.73 0 0 1 0 4.09h2.53v-.12a11.23 11.23 0 0 0-3.42-10.69",
    fill: "#263238"
  }), React.createElement("path", {
    d: "M457.5 561.38a11.52 11.52 0 0 0 0-7.41 2.7 2.7 0 0 0-2.53-2.69h.17a2.7 2.7 0 0 1 2.7 2.7 11.52 11.52 0 0 1 0 7.41c-.07.21-.78.27-1.67.26.77-.02 1.33-.09 1.33-.27z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M457.89 553.93s7-4.88 6.27-11.06h-1.56s-3.75 8.1-6.14 8.89 1.43 2.17 1.43 2.17z",
    fill: "#00695c"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M454.84 564.35l-2.39 7.87h-.35l2.44-8zM457.5 561.42h.35a11.23 11.23 0 0 1 3.42 10.69v.12h-.35v-.12a11.23 11.23 0 0 0-3.42-10.69z"
  })), React.createElement("path", {
    d: "M463.9 542.93h.26c.7 6.19-6.27 11.06-6.27 11.06l-.17-.07c.78-.57 6.83-5.2 6.18-10.99z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M457.34 546.71a4.47 4.47 0 0 0-.31 1.09 2.92 2.92 0 0 1-1.24 1.9 2.74 2.74 0 0 1-1.21.33 2.31 2.31 0 0 1-1.79-.54 2.22 2.22 0 0 1-.55-1.1 3.74 3.74 0 0 1 1-3.44 3.32 3.32 0 0 1 3.45-.73 3.3 3.3 0 0 0 .66.24 1.09 1.09 0 0 0 1-.32.6.6 0 0 1-.58.78 1.68 1.68 0 0 0 1.29.07 1.09 1.09 0 0 1-1.38.55 3.69 3.69 0 0 0 1.56.32c-.11 0-.33.21-.47.25a3 3 0 0 1-.52 0 1 1 0 0 0-.91.6z",
    fill: "#263238"
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M457.7 544.93a1.67 1.67 0 0 0 .64.16 1.68 1.68 0 0 1-.84-.16.61.61 0 0 0 .61-.66l.14-.12a.6.6 0 0 1-.55.78zM457.16 544.46a3.3 3.3 0 0 1-.66-.24 3 3 0 0 0-1-.21 3 3 0 0 1 1.21.21 3.3 3.3 0 0 0 .66.24h.09a1 1 0 0 1-.3 0zM458.5 546.11c.14 0 .36-.25.47-.25a3.69 3.69 0 0 1-1.56-.32 1 1 0 0 0 .35.07 3.69 3.69 0 0 0 1.39.24c-.11 0-.33.21-.47.25a1.16 1.16 0 0 1-.36 0zM454.4 550.03a2.74 2.74 0 0 0 1.21-.33 2.92 2.92 0 0 0 1.24-1.9 4.47 4.47 0 0 1 .31-1.09 1 1 0 0 1 .85-.56h.17a1 1 0 0 0-.85.56 4.47 4.47 0 0 0-.31 1.09 2.92 2.92 0 0 1-1.24 1.9 2.74 2.74 0 0 1-1.21.33h-.17zM457.91 545.62a1.1 1.1 0 0 0 .89-.57l.2-.06a1.1 1.1 0 0 1-1.09.63z"
  })), React.createElement("path", {
    d: "M463.99 542.86s.52-.44 0-1.22a.83.83 0 0 0-.65-.4.85.85 0 0 1 .82.4c.52.78 0 1.22 0 1.22a4.72 4.72 0 0 1-1 .11 5.16 5.16 0 0 0 .83-.11z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M475.91 533.15s-2.57 8.11 1.74 12.6l1.25-1s-2.55-8.85-1.12-10.93c-2.52-.79-1.87-.67-1.87-.67z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M477.69 533.87s.52-.44 0-1.22-1.48-.17-1.48-.17-.35 1.13 0 1.39 1.48 0 1.48 0z",
    fill: "#f6b9ad"
  }), React.createElement("rect", {
    x: 637.1,
    y: 634.78,
    width: 2.44,
    height: 3.62,
    rx: 1.12,
    ry: 1.12,
    transform: "rotate(180 559.075 589.555)",
    fill: "#f6b9ad"
  }), React.createElement("path", {
    d: "M478.72 545.32s-2.52-8.74-1.15-10.89h.26c-1.43 2.08 1.12 10.93 1.12 10.93l-1.25 1-.11-.12z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 479.78,
    cy: 539.27,
    r: 2.7,
    fill: "#f6b9ad"
  }), React.createElement("path", {
    d: "M480.74 543.1v-1.17a1.21 1.21 0 0 0 0-.26 2.7 2.7 0 0 0-1.08-5.1h.15a2.7 2.7 0 0 1 1.24 5.1 1.21 1.21 0 0 1 0 .26v1.18a1.22 1.22 0 0 1-1.22 1.22h-.15a1.22 1.22 0 0 0 1.06-1.23z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M477.04 552.73s5.21.59 5.4 0c.62-1.9-1-4-.21-5a2.47 2.47 0 0 0 .21-2.44 2.7 2.7 0 0 0-2.7-2.7 2.7 2.7 0 0 0-2.7 2.7z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M482.24 547.77a2.47 2.47 0 0 0 .21-2.44 2.7 2.7 0 0 0-2.7-2.7h-.17a2.7 2.7 0 0 1 2.53 2.69 2.47 2.47 0 0 1-.21 2.44c-.84 1 .83 3.06.21 5-.06.18-.6.25-1.31.26.88 0 1.59-.05 1.66-.26.61-1.93-1.06-3.99-.22-4.99z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M481.33 552.56a15.46 15.46 0 0 1 2.2 10.69v.12h-1.62a8.7 8.7 0 0 0 0-4.09 6.46 6.46 0 0 0-2.46-3.92l-1.57 8h-1.51l1.51-10.8zM490.5 537.02s.63-.26.36-1.17-1.36-.6-1.36-.6-.67 1-.41 1.33 1.41.44 1.41.44z",
    fill: "#f6b9ad"
  }), React.createElement("path", {
    d: "M481.25 545.76s8.09-2.62 9.24-8.74l-1.5-.46s-6 6.65-8.48 6.7.74 2.5.74 2.5z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M490.21 537.03l.25.08c-1.15 6.12-9.24 8.74-9.24 8.74l-.14-.11c.95-.34 8.06-3 9.13-8.71z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M479.08 555.35l-1.57 8h.35l1.52-7.78a3.74 3.74 0 0 0-.3-.22zM481.33 552.56h-.35a15.46 15.46 0 0 1 2.2 10.69v.12h.32v-.12a15.46 15.46 0 0 0-2.17-10.69z"
  })), React.createElement("path", {
    d: "M490.32 536.93s.63-.26.36-1.17a.83.83 0 0 0-.5-.57.85.85 0 0 1 .67.62c.27.9-.36 1.17-.36 1.17a4.72 4.72 0 0 1-1-.19 5.16 5.16 0 0 0 .83.14z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M477.04 552.44l-3.28 6.92a40.62 40.62 0 0 1 5.71.69c3.63.69 5.36-1 5.36-1l-2.33-6.61z",
    fill: "#263238"
  }), React.createElement("path", {
    d: "M477.91 563.33s1.73.35 1.38 1h-3.11l.17-1zM483.44 563.33s1.73.35 1.38 1h-3.11l.17-1z",
    fill: "#ff5252"
  }), React.createElement("path", {
    d: "M482.23 537.05s-4.15 5.88-2.25 8.3l-7.43-.17s2.07-13.32 9.68-8.13z",
    fill: "#fccc63"
  }), React.createElement("path", {
    d: "M482.23 537.05a6.31 6.31 0 0 0-2.9-1.18 7.32 7.32 0 0 1 2 1s-4.15 5.88-2.25 8.3l-6.54-.15v.15l7.43.17c-1.89-2.41 2.26-8.29 2.26-8.29zM482.5 552.44h-.52l2.34 6.57a5.28 5.28 0 0 1-3.44 1.2 5.5 5.5 0 0 0 4-1.2zM477.91 563.33h-.35s1.73.35 1.38 1h.35c.35-.66-1.38-1-1.38-1zM483.44 563.33h-.35s1.73.35 1.38 1h.35c.35-.66-1.38-1-1.38-1z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "none",
    stroke: "#b3b3b3",
    strokeMiterlimit: 10,
    d: "M725.52 400.93l-9.64-53.84 30.53-1.49v55.33h20.89l20.89-59.46"
  }), React.createElement("rect", {
    x: 704.63,
    y: 395.3,
    width: 83.56,
    height: 59.46,
    rx: 27.3,
    ry: 27.3,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M759.27 395.3h-24.1a29.82 29.82 0 0 0-29.73 29.73c0 .68 0 1.34.08 2a29.82 29.82 0 0 1 29.65-27.72h24.1a29.82 29.82 0 0 1 29.65 27.72c0-.66.08-1.33.08-2a29.82 29.82 0 0 0-29.73-29.73z",
    opacity: 0.05
  }), React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M765.66 413.01l-7.89-6.19-19.08 24.17-10.26-7.95-6.42 8.16 14.92 11.4 3.7 2.97 25.03-32.56z"
  }), React.createElement("path", {
    fill: "#69f0ae",
    d: "M765.08 412.86l-7.16-5.48-18.95 24.72-10.53-8.08-5.49 7.16 14.11 10.8 3.62 2.71 24.4-31.83z"
  }), React.createElement("path", {
    d: "M1031.67 328.46c0 68.66-57.36 124.32-118.43 124.32s-123.66-55.66-123.66-124.32 62.59-124.32 123.67-124.32 118.42 55.66 118.42 124.32z",
    transform: "translate(-158.5 -94.07)",
    fill: "url(#prefix__f)"
  }), React.createElement("path", {
    d: "M867.5 234.39c0 65.45-54.67 118.5-112.89 118.5s-117.88-53.05-117.88-118.5 59.68-118.46 117.89-118.46 112.88 53 112.88 118.46zM736.53 357.05h26.19v9.15h-26.19z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M754.62 115.48c-1.39 0-2.77 0-4.16.1 56.63 2.45 108.73 54.51 108.73 118.4s-52.1 115.95-108.69 118.4c1.39.06 2.78.1 4.16.1 58.21 0 112.89-53.05 112.89-118.5s-54.72-118.5-112.93-118.5z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M643.4 234.39c0-64.51 58-117 115.38-118.46h-2.49c-58.21 0-117.88 53.05-117.88 118.5s59.66 118.5 117.87 118.5h2.49c-57.4-1.56-115.37-54-115.37-118.54z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M713.25 336.26h75.26v24.53h-75.26z"
  }), React.createElement("path", {
    d: "M713.25 124.52s-89.39 102.18 0 219.74l29.52-.1s-81.49-97.12-3.74-227l-14.53 3.31zM791 122.93s89.39 103.74 0 221.3l-29.52-.1s81.49-98 3.74-227.85l14.55 2.91z",
    fill: "#fff",
    opacity: 0.2
  }));
};
UndrawAirSupport.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawAirSupport;